import { colors } from '@material-ui/core';

const styles = {
  root: {
    backgroundColor: colors.grey[50]
  }
};

export default styles